import { State } from "./state";
import { Mask } from "../../../shared";
import { storeInit } from "../../../Store";

export const emptyCommands = {
  ["/ATX/hardware/flags/mask"]: ["x", "x", "x", "x", "x", "x", "x", "x"] as Mask
};

const input: State.Input = {
  id: "",
  status: false,
  cmds: emptyCommands
};

const inputs: State.Input[] = [
  { ...input },
  { ...input },
  { ...input },
  { ...input },
  { ...input },
  { ...input },
  { ...input },
  { ...input }
];

export const initial: State.Props = storeInit(inputs);
export default initial;
